<template>
  <ToggleSection label="Sample Lineage" :collapsed="!dv.isEditing">
    <FieldGrid :fields="fieldsGrid" :dv="dv">
      <template #derivesFrom>
        <div v-if="dv.isEditing" class="control radio-group mr-4">
          <label
            v-for="[key, value] in Object.entries(derivedOptions)"
            :key="key"
            class="radio mr-2"
          >
            <input
              v-model="derivesFrom"
              type="radio"
              name="derives_from"
              :value="key"
            />
            {{ value }}
          </label>
        </div>
        <span v-else>
          {{ derivedOptions[derivesFrom] }}
        </span>
      </template>
    </FieldGrid>
  </ToggleSection>
</template>

<script>
import { computed, ref, watch } from 'vue'

import FieldGrid from '@/components/fields/FieldGrid.vue'
import ToggleSection from '@/components/fields/ToggleSection.vue'

export default {
  name: 'SampleLineageDescription',
  components: { ToggleSection, FieldGrid },
  props: {
    dv: { type: Object, required: true },
  },
  setup(props) {
    const derivedOptions = {
      specimen: 'Specimen',
      sample: 'Sample',
      none: 'None',
    }

    function getInitialDerivesFrom() {
      const parentsData = props.dv.editedRecord?.['parents']
      const specimenData = props.dv.editedRecord?.['specimen']

      if (parentsData?.value?.length > 0) {
        return 'sample'
      } else if (
        specimenData?.value &&
        Object.keys(specimenData.value)?.length > 0
      ) {
        return 'specimen'
      }
      return 'none'
    }

    const derivesFrom = ref(getInitialDerivesFrom())

    const fieldsGrid = computed(() => {
      const rows = [['slot:fc:derivesFrom:Derives from']]
      if (derivesFrom.value === 'specimen') rows.push(['specimen'])
      else if (derivesFrom.value === 'sample') rows.push(['parents'])
      rows.push(['children'])
      return rows
    })

    watch(derivesFrom, (value) => {
      switch (value) {
        case 'none':
          props.dv.edit({ name: 'parents' }, [])
          props.dv.edit({ name: 'specimen' }, {})
          break
        case 'sample':
          props.dv.edit({ name: 'specimen' }, {})
          props.dv.edit({ name: 'parents' }, props.dv.record['parents'].value)
          break
        case 'specimen':
          props.dv.edit({ name: 'parents' }, [])
          props.dv.edit({ name: 'specimen' }, props.dv.record['specimen'].value)
          break
      }
    })

    return { derivedOptions, derivesFrom, fieldsGrid }
  },
}
</script>
